import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ResetPasswordService } from '@account/services/resetPassword.service';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordGuard implements CanActivate {
  response: boolean;
  constructor(private resetPasswordService: ResetPasswordService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.resetPasswordService.validKeyMailPassword(route.params.key).pipe(
      map(
        (result) => {
          this.response = result;
          if (!this.response) {
            this.router.navigate(['/linkExpired']);
            return false;
          } else {
            return true;
          }
        },
        (err) => {
          this.router.navigate(['/linkExpired']);
          return false;
        }
      ),
      catchError((error) => {
        this.router.navigateByUrl('/login');
        return of(false);
      })
    );
  }
}
